export default [
    {title: "General.ConsumptionMethod.Weekly", value: "Weekly"},
    {title: "General.ConsumptionMethod.Monthly", value: "Monthly"},
    {title: "General.ConsumptionMethod.Annually", value: "Annually"}
]
